import {
    fetchDictByRoot,
    fetchCompanyTree,
    fetchCurrentTenantArea,
} from "@/api/dict";
import { getCurrentInstance } from "vue";

export default {
    namespaced: true, // 启用命名空间（重要！）
    state: {
        productTypeData: [],
        companyTreeData: [],
        currentTenantAreaData: {},
        userInfoData: {},
    },
    actions: {
        // 根据Root根租户获取字典
        async getProductType({ commit }, dictStr) {
            try {
                const res = await fetchDictByRoot(dictStr);
                if (res.code == 200) {
                    const currentTenant = localStorage.getItem("X-From-Tenant");
                    res.data &&
                        res.data.forEach((item) => {
                            item.expandInfo = Number(item.expandInfo);
                            item.metaData = Number(item.metaData);
                            if (item.metaData === 1) {
                                item.dictName = "双摄 网约车业务";
                            } else if (item.metaData === 2) {
                                item.dictName = "单摄 短租车业务";
                            }
                        });
                    if (currentTenant === "10049") {
                        res.data = res.data.filter((item) => item.metaData !== 1 && item.metaData !== 2);
                    }
                    commit("SET_BYROOTDICT", res.data);
                }
            } catch (error) {
                // 处理错误
            }
        },
        // 分公司树状结构
        async getCompanyTree({ commit }) {
            try {
                const res = await fetchCompanyTree();
                if (res.code == 200) {
                    commit("SET_COMPANYTREE", res.data);
                }
            } catch (error) {
                // 处理错误
            }
        },
        async getCurrentTenantArea({ commit }) {
            try {
                const res = await fetchCurrentTenantArea();
                if (res.code == 200) {
                    commit("SET_CURRENTTENANTAREA", res.data);
                }
            } catch (error) {}
        },
        // userInfo
        getLocalUserInfo({ commit }) {
            if (localStorage.getItem("userInfo")) {
                commit(
                    "SET_USERINFO",
                    JSON.parse(localStorage.getItem("userInfo"))
                );
            } else {
                commit("SET_USERINFO", { nickName: "匿名用户" });
            }
        },
    },
    getters: {
        productTypeData: (state) => state.productTypeData,
        companyTreeData: (state) => state.companyTreeData,
        userInfoData: (state) => state.userInfoData,
    },
    mutations: {
        SET_BYROOTDICT(state, data) {
            state.productTypeData = data;
        },
        SET_COMPANYTREE(state, data) {
            state.companyTreeData = data;
        },
        SET_CURRENTTENANTAREA(state, data) {
            state.currentTenantAreaData = data;
        },
        SET_USERINFO(state, data) {
            state.userInfoData = data;
        },
    },
};
